import React, { useState } from 'react';
import Input from './Input';

function InputWithValidation(props) {
    const [errorText, setErrorText] = useState("");
    const [type, setType] = useState(props.type);
    const [iconSrc, setIconSrc] = useState(`${cdnPath}/images/icons/eye-hide.png`);

    function onChange(value) {
        var res = props.validation(value);
        if (res === true) {
            setErrorText("");
            props.onChange({ val: value, valid: true });
        } else {
            setErrorText(res);
            props.onChange({ val: value, valid: false });
        }
    }

    function togglePassword(){
        setIconSrc(type == "password" ? `${cdnPath}/images/icons/eye-show.png` : `${cdnPath}/images/icons/eye-hide.png`)
        setType(type == "password" ? "text" : "password")
    }

    return (
        <div className="input-with-validation">
            <Input
                placeholder={props.placeholder}
                onChange={onChange}
                value={props.value.val}
                type={type}
                onFocus={props.onFocus}
            />
            {props.type == "password" && (
                <img className='passwordEye' src={iconSrc} onClick={togglePassword} />
            )}
            {
                !props.value.valid && 
                <div className="error-text">
                    {errorText === "" ? props.errorText : errorText}
                </div>
            }     
        </div>
    );
}

export default InputWithValidation;